export interface LinkPreview {
  title?: string;
  description?: string;
  favicon?: string;
  host: string;
  image?: string;
}

export const getLinkPreview = async (url: string): Promise<LinkPreview | null> => {
    if (!url || !url.startsWith('http')) {
        return null;
    }

    try {
        const host = new URL(url).hostname;
    
        // 这里可以调用后端 API 来获取真实的链接预览信息
        // 目前使用模拟数据，实际项目中应该调用类似 LinkPreview API 的服务
        return {
            title: `Link to ${host}`,
            description: `Visit ${host} for more information`,
            host: host,
            favicon: `https://www.google.com/s2/favicons?domain=${host}&sz=32`
        };
    } catch (error) {
        console.error('Failed to get link preview:', error);
        return null;
    }
};

// 获取网站 favicon 的备用方案
export const getFavicon = (host: string): string => {
    return `https://www.google.com/s2/favicons?domain=${host}&sz=32`;
};

// 解析 URL 获取 host
export const getHost = (url: string): string => {
    try {
        const urlObj = new URL(url);
        return urlObj.hostname;
    } catch {
        return url;
    }
}; 